export class QueryRequestDto implements IQueryRequestDto{
    message: string;
    payment: IUserPaymentDto;
}